import './css/style.css';
import './css/custom.css';
import './css/beyond.min.css';
import './css/animate.min.css';
import Navigator from "./components/Navigator";
const App = () => {
  return <Navigator/>;
};

export default App;